module.exports = __webpack_public_path__ + "img/side-icon-55-off.66b89504.svg";